import React, { useState } from 'react';

const EmailTab = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setError('');
    setSuccess('');
  };

  const handleSendEmail = async () => {
    setError('');
    setSuccess('');

    if (!email.trim()) {
      setError('Email address is required');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);

    try {
      // Make API call to the correct send-intro-email endpoint
      const response = await fetch('https://lumibackend.norta.ai/api/Email/send-intro-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
        },
        body: JSON.stringify({
          emailId: email
        })
      });

      if (response.ok) {
        // Email sent successfully
        setSuccess(`Email sent successfully to ${email}`);
        setEmail('');
      } else {
        // Handle HTTP error responses
        let errorMessage = `Failed to send email: ${response.status} ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData && errorData.error) {
            errorMessage = errorData.error;
          } else if (errorData) {
            errorMessage += ` - ${JSON.stringify(errorData)}`;
          }
        } catch (e) {
          // If we can't parse JSON, try as text
          try {
            const textData = await response.text();
            if (textData) {
              errorMessage += ` - ${textData}`;
            }
          } catch (e2) {
            // If we can't read the error response, just use the status
          }
        }
        setError(errorMessage);
      }
    } catch (error) {
      // Handle network errors, connection issues, etc.
      let errorMessage = `Error sending email: ${error.message}`;
      if (error.message === 'Failed to fetch') {
        errorMessage = 'Unable to connect to the email service. Please check your internet connection and try again.';
      }
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isLoading) {
      handleSendEmail();
    }
  };

  return (
    <div>
      <h2 style={{ marginBottom: '16px', color: '#333' }}>Send Email</h2>
      <p className="tab-description">
        Enter an email address to send an introduction email. The email format will be validated before sending to the email service.
      </p>
      
      <div className="input-group">
        <input
          type="email"
          value={email}
          onChange={handleEmailChange}
          onKeyPress={handleKeyPress}
          placeholder="Enter email address (e.g., user@example.com)"
          className={`input-field ${error ? 'error' : ''}`}
          disabled={isLoading}
        />
        <button
          onClick={handleSendEmail}
          disabled={isLoading}
          className="action-btn"
        >
          {isLoading ? 'Sending...' : 'Send Mail'}
        </button>
      </div>
      
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}
      
      {error && error.includes('valid email') && (
        <div style={{ marginTop: '24px', padding: '16px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <h4 style={{ marginBottom: '8px', color: '#495057' }}>Email Format Requirements:</h4>
          <ul style={{ color: '#6c757d', fontSize: '14px', paddingLeft: '20px' }}>
            <li>Must contain @ symbol</li>
            <li>Must have a domain (e.g., example.com)</li>
            <li>No spaces allowed</li>
            <li>Examples: user@example.com, admin@company.org</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default EmailTab;
